import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Http } from "@angular/http";
import { UtilService } from "../util/util.service";
import { ScannedSpecimen } from "app/shared/models";

@Injectable()
export class AccessionService {
  constructor(private http: Http, private utilService: UtilService) {}

  accessionStart(encounterID: string): Observable<any> {
    const url = `/encounters/${encounterID}/accessionings`;
    return this.http
      .post(url, { status: "active" })
      .catch(this.utilService.handleError);
  }

  accession(encounterID: string, specimenIDs: ScannedSpecimen): Observable<any> {
    const url = `/accessionings/${encounterID}/specimens`;
    const formData = JSON.stringify(specimenIDs);
    return this.http.post(url, formData).catch(this.utilService.handleError);
  }

  accessionComplete(encounterID: string): Observable<any> {
    const url = `/accessionings/${encounterID}/complete`;
    return this.http.post(url, "").catch(this.utilService.handleError);
  }

  getSpecimensByFacilityAndSpecimen(specimenId: string): Observable<any> {
    const url = "/chart/specimens";
    const payload = {
      q: specimenId
    }
    return this.http.post(url, payload)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/accession/accession.service.ts